module.exports = __webpack_public_path__ + "img/1280x720-Meeting.063cabcb.jpg";